import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UploadExportInvoicePdfRequest } from "src/app/domain/models/ExportInvoice";

@Injectable({providedIn: 'root'})
export abstract class ExportInvoiceGateway {
  abstract uploadExportInvoicePdf(request: UploadExportInvoicePdfRequest): Observable<any>
}
